import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Cell,
  Tooltip,
  LabelList,
  ResponsiveContainer,
  Label,
  Legend,
  Brush,
} from "recharts";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { Switch } from "@material-ui/core";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import "./DataQualityGraph.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import DataViewer from "./DataViewer";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";

import { loadingOn } from "../../Utils/utils";
import { Card } from "react-bootstrap";

import {
  getDateDataprovider,
  getDataQuality,
  getLogMnemonic,
  getChannelTemplate,
  getDataQualityTime,
  getHistoricalDevices,
} from "./../../Utils/actions/yh";
import { MaterialReactTable } from "material-react-table";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import * as d3 from "d3";

const useStyle = makeStyles((theme) => ({}));
// import { useLocation } from 'react-router-dom';
const DataQualityGraph = ({
  setDQGraph,
  activeWell,
  wellProviderData,
  selectedRig,
  logJobs,
  selectedJobDate,
  yhAddress,
  yhPort,
  jobDate,
  rigWellData,
  dataProviderName,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    // rigWellData,
    rigCardData,
    // dataQualityTime,
    // dataQualityTotalRecord,
    // dataQualityLoading,
    dataProviderAll,
    channelList,
    dataQualityTotalRecordNew,
    logMnemonicData,
    ChannelTemplateRecords,
    aspectTemplateRecords,
    aspectTemplateDayRecords,
    historicalDevices,
    loading,
    aspectdayTotalRecords,
  } = useSelector((state) => state.yh);

  const classes = useStyle();
  const dispatch = useDispatch();
  const [Json, setJson] = useState();
  const [clickedLog, setClickedLog] = useState("");
  const [clickedDate, setClickedDate] = useState("");
  const [clickedMnemonic, setClickedMnemonic] = useState("");
  const [selectDropdown, setSelectDropdown] = useState("dqi");
  const [selectedDataProvider, setSelectedDataProvider] =
    useState(dataProviderName);
  const [selectedWell, setSelectedWell] = useState(activeWell);
  const [dropdownRig, setDropdownRig] = useState(selectedRig);
  const [smallestMnemonic, setSmallestMnemonic] = useState("");
  const [isInverted, setIsInverted] = useState(false);
  const [show, setShow] = useState(false);
  const [clickedAspectDate, setClickedAspectDate] = useState();
  const [indexMnemonic, setIndexMnemonic] = useState("");
  const [indexMnemonicURI, setIndexMnemonicURI] = useState("");
  const [deviceType, setDeviceType] = useState("");
  const [mnemonicLoading, setMnemonicLoading] = useState(false);
  const [smallestDate, setSmallestDate] = useState("");
  const [largestDate, setLargestDate] = useState("");
  const [DVdate, setDvdate] = useState();
  const { t } = useTranslation();
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(
    sessionStorage.getItem("aspectPageSize")
      ? sessionStorage.getItem("aspectPageSize")
      : 10
  );
  const [switchChange, setSwitchChange] = useState(true);
  const svgRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(loadingOn());
        await Promise.all([
          dispatch(getDateDataprovider(selectedWell)),
          dispatch(getDataQuality(selectedWell, selectedDataProvider)),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dropdownRig, selectedWell, selectedDataProvider]);

  sessionStorage.setItem("aspectPageSize", pageSize);

  useEffect(() => {
    dispatch(getLogMnemonic(dropdownRig, selectedWell, selectedDataProvider));

    // eslint-disable-next-line
  }, [clickedDate, dropdownRig, selectedWell, selectedDataProvider]);

  useEffect(() => {
    if (clickedDate || clickedLog || smallestMnemonic) {
      dispatch(loadingOn());

      dispatch(
        getChannelTemplate(
          dropdownRig,
          selectedWell,
          selectedDataProvider,
          clickedDate,
          clickedLog,
          smallestMnemonic,
          pageSize,
          pageIndex
        )
      );
    }
  }, [
    clickedDate,
    clickedLog,
    smallestMnemonic,
    dropdownRig,
    selectedWell,
    selectedDataProvider,
    pageSize,
    pageIndex,
  ]);

  const handleClose = () => {
    setShow(false);
    setDvdate("");
  };

  const handleChange = (event) => {
    const newWell = event.target.value;
    setSelectedWell(newWell);

    if (location.state !== null) {
      if (
        location.state.jobDate != undefined &&
        location.state.jobDate != null
      ) {
        location.state.jobDate = "";
      }
      if (location.state.logs != undefined && location.state.logs != null) {
        location.state.logs = "";
      }
    }

    // Use the newly selected well directly
    setSelectedDataProvider(wellProviderData[newWell]?.[0] || "");

    setClickedDate("");
  };

  const handleLogChange = (event) => {
    setClickedLog(event.target.value);
  };

  useEffect(() => {
    if (
      clickedLog &&
      logMnemonicData &&
      logMnemonicData[clickedLog] &&
      logMnemonicData[clickedLog].length > 0
    ) {
      const [[key, value]] = Object.entries(logMnemonicData[clickedLog][0]);
      setSmallestMnemonic(key);
    }
  }, [clickedLog]);

  const handleMnemonicChange = (event) => {
    setSmallestMnemonic(event.target.value);
  };

  const handleDataProviderChange = (event) => {
    setSelectedDataProvider(event.target.value);

    if (location.state !== null) {
      if (
        location.state.jobDate != undefined &&
        location.state.jobDate != null
      ) {
        location.state.jobDate = "";
      }
      if (location.state.logs != undefined && location.state.logs != null) {
        location.state.logs = "";
      }
    }
    setClickedDate("");
  };

  const handleRigChange = (event) => {
    const newRig = event.target.value;
    setDropdownRig(newRig);

    if (location.state !== null) {
      if (
        location.state.jobDate != undefined &&
        location.state.jobDate != null
      ) {
        location.state.jobDate = "";
      }
      if (location.state.logs != undefined && location.state.logs != null) {
        location.state.logs = "";
      }
    }

    const activeWellForRig = rigWellData[newRig]?.includes(activeWell)
      ? activeWell
      : rigWellData[newRig]?.[0] || "Select a Well";
    setSelectedWell(activeWellForRig);

    setClickedDate("");

    const dataProvidersForWell = wellProviderData[activeWellForRig];
    setSelectedDataProvider(
      dataProvidersForWell && dataProvidersForWell.length > 0
        ? dataProvidersForWell[0]
        : null
    );

    if (clickedLog || clickedDate) {
      setClickedDate(smallestDate);
    }
  };

  useEffect(() => {
    if (clickedLog || clickedDate) {
      setClickedDate(smallestDate);
    }
    if (selectedJobDate) {
      setClickedDate(selectedJobDate);
    }
  }, [smallestDate]);

  useEffect(() => {
    if (selectedJobDate && logJobs) {
      setClickedDate(selectedJobDate);
      setClickedLog(logJobs);
    }
  }, [selectedJobDate, logJobs]);

  useEffect(() => {
    if (clickedDate || clickedLog) {
      if (logMnemonicData && Object.keys(logMnemonicData).length > 0) {
        if (logJobs !== undefined) {
          setClickedLog(logJobs);

          if (logMnemonicData[logJobs]?.length > 0) {
            const [[key, value]] = Object.entries(logMnemonicData[logJobs][0]);
            setSmallestMnemonic(key);
          }
        } else {
          setClickedLog(Object.keys(logMnemonicData)[0]);

          if (logMnemonicData[Object.keys(logMnemonicData)[0]]?.length > 0) {
            const [[key, value]] = Object.entries(
              logMnemonicData[Object.keys(logMnemonicData)[0]][0]
            );
            setSmallestMnemonic(key);
          }
        }
      }
    }
  }, [logMnemonicData]);

  const handleDateChange = (event) => {
    setClickedDate(event.target.value);
  };

  // const colors = [
  //   "#46a2da",
  //   "#1F5372",
  //   "#212C68",
  //   "#008ECC",
  //   "#45b6fb",
  //   "#16618d",
  //   "#053f67",
  // ];

  const colors = [
    "#00BFFF",
    "#A970FF",
    "#FF8C42",
    "#00FA9A",
    "#7FFFD4",
    "#FF69B4",
    "#6F00FF",
    "#00CED1",
    "#FF6F61",
  ];
  //--------------------------------------log bar chart-----------------------

  const handleChannelClick = (data) => {
    setClickedMnemonic(data.name);
    setSmallestMnemonic(data.name);
  };

  const handleLogBar = (date) => {
    setClickedDate(date);

    if (logMnemonicData && Object.keys(logMnemonicData).length > 0) {
      setClickedLog(Object.keys(logMnemonicData)[0]);

      if (logMnemonicData[Object.keys(logMnemonicData)[0]]?.length > 0) {
        const [[key, value]] = Object.entries(
          logMnemonicData[Object.keys(logMnemonicData)[0]][0]
        );
        setSmallestMnemonic(key);
      }
    }
  };

  //--------------------------------------Aspect Pie chart-----------------------

  const pieWellData =
    dataQualityTotalRecordNew && dataQualityTotalRecordNew.data
      ? Object.entries(dataQualityTotalRecordNew.data).map(([date, value]) => ({
          name: date,
          value,
        }))
      : [];

  useEffect(() => {
    if (dataQualityTotalRecordNew && dataQualityTotalRecordNew.data) {
      const reKey = dataQualityTotalRecordNew.data;
      const keysdate = Object.keys(reKey);
      keysdate.sort((a, b) => new Date(a) - new Date(b));
      setSmallestDate(keysdate[0]);
      setLargestDate(keysdate[keysdate.length - 1]);
    } else {
      setClickedDate("");
    }
  }, [dataQualityTotalRecordNew]);

  const barLogData =
    dataQualityTotalRecordNew && dataQualityTotalRecordNew.data
      ? Object.entries(dataQualityTotalRecordNew.data)
          .map(([date, value]) => ({
            name: date,
            value: isInverted ? 100 - value : value,
          }))
          .filter((dataPoint) => dataPoint.value !== 0)
      : [];
  barLogData.sort((a, b) => new Date(a.name) - new Date(b.name));

  const barMnemonicData =
    ChannelTemplateRecords && ChannelTemplateRecords.data
      ? Object.entries(ChannelTemplateRecords.data).map(([date, value]) => ({
          name: date,
          value,
        }))
      : [];
  barMnemonicData.sort((a, b) => a.value - b.value);

  const pieAspectData =
    aspectTemplateRecords && aspectTemplateRecords
      ? Object.entries(aspectTemplateRecords).map(([date, value]) => ({
          name: date,
          value,
        }))
      : [];

  const legendData = [
    // { color: "#212C68", name: "Excellent" },
    { color: "#66b266", name: "Good" },
    { color: "#ffd96a", name: "Average" },
    { color: "#ff6666", name: "Bad" },
    // { color: "red", name: "Not-acceptable" }
  ];

  // const colorRenderPieChart = renderPieChart();
  const colorRenderRecordsChart = pieAspectData;

  const avgColorsMap = new Map();
  const avgcolorsChannelsMap = new Map();
  const avgcolorsAspectsMap = new Map();

  pieWellData.forEach((entry) => {
    const { name, value } = entry;
    let color = null;

    legendData.forEach((item) => {
      if (value < 20 && item.name === "Not-acceptable") {
        color = item.color;
      } else if (value >= 20 && value < 50 && item.name === "Bad") {
        color = item.color;
      } else if (value >= 50 && value < 70 && item.name === "Average") {
        color = item.color;
      } else if (value >= 70 && value < 90 && item.name === "Good") {
        color = item.color;
      } else if (value >= 90 && item.name === "Excellent") {
        color = item.color;
      }
    });

    if (!color) {
      const colorIndex = avgColorsMap.size % colors.length;
      color = colors[colorIndex];
    }

    avgColorsMap.set(value, color);
  });

  colorRenderRecordsChart.forEach((entry) => {
    const { name, value } = entry;
    let color;

    selectDropdown === "aswi"
      ? legendData.forEach((item) => {
          if (value < 2 && item.name === "Not-acceptable") {
            color = item.color;
          } else if (value >= 2 && value < 5 && item.name === "Bad") {
            color = item.color;
          } else if (value >= 5 && value < 7 && item.name === "Average") {
            color = item.color;
          } else if (value >= 7 && value < 9 && item.name === "Good") {
            color = item.color;
          } else if (value >= 9 && item.name === "Excellent") {
            color = item.color;
          }
        })
      : legendData.forEach((item) => {
          if (value >= 3500 && item.name === "Not-acceptable") {
            color = item.color;
          } else if (value >= 3000 && value < 3500 && item.name === "Bad") {
            color = item.color;
          } else if (value >= 2000 && value < 3000 && item.name === "Average") {
            color = item.color;
          } else if (value >= 1800 && value < 2000 && item.name === "Good") {
            color = item.color;
          } else if (value < 1800 && item.name === "Excellent") {
            color = item.color;
          }
        });

    if (!color) {
      const colorIndex = avgcolorsAspectsMap.size % colors.length;
      color = colors[colorIndex];
    }

    avgcolorsAspectsMap.set(value, color);
  });

  //for aswi and dqi switch
  const handleButtonClick = (value) => {
    setSelectDropdown(value);
  };

  const legendDataPayload = legendData.map((entry) => ({
    value: entry.name,
    type: "square",
    color: entry.color,
  }));

  const centerWrapperStyle = {
    position: "absolute",
    bottom: "2px",
    fontSize: "16px",
    display: "flex",
    alignItems: "flex-start",
    overflow: "visible !important",
    left: "55%",
    transform: "translateX(-50%)",
    justifyContent: "center",
  };
  const centerWrapperStyle1 = {
    position: "relative",
    height: "0px",
  };

  const CommonLegend1 =
    clickedDate || clickedLog ? (
      <Legend
        wrapperStyle={centerWrapperStyle1}
        layout="horizontal"
        payload={legendDataPayload}
        style={{ fontSize: "16px" }}
      />
    ) : null;

  const CommonLegend =
    !clickedDate || !clickedLog ? (
      <Legend
        layout="horizontal"
        wrapperStyle={centerWrapperStyle}
        payload={legendDataPayload}
        className="centerWrapperStyle"
      />
    ) : (
      ""
    );

  const resetGroupedChartData = () => {
    setDQGraph(false);
    // if(location.pathname === '/dq'){
    // location.state = {}
    // }
    navigate("/dq", { replace: true });
  };

  const aspectTemplateDayRecordsTime = aspectTemplateDayRecords.map((time) => {
    const startPointDate = new Date(time.startPoint);
    const endPointDate = new Date(time.endPoint);

    const startPointFormatted = startPointDate
      .toISOString()
      .slice(0, 19)
      .replace("T", " ");
    const endPointFormatted = endPointDate
      .toISOString()
      .slice(0, 19)
      .replace("T", " ");

    if (ChannelTemplateRecords?.deviceType === "DEPTHSERIES") {
      return {
        ...time,
      };
    } else {
      return {
        ...time,
        startPoint: startPointFormatted,
        endPoint: endPointFormatted,
      };
    }
  });

  const roleColumns = useMemo(() => {
    const minHeader =
      ChannelTemplateRecords?.deviceType === "DEPTHSERIES"
        ? "Min (ft)"
        : "Min (Sec)";
    const staleHeader =
      ChannelTemplateRecords?.deviceType === "DEPTHSERIES"
        ? "Stale (ft)"
        : "Stale (Sec)";
    const maxHeader =
      ChannelTemplateRecords?.deviceType === "DEPTHSERIES"
        ? "Max (ft)"
        : "Max (Sec)";
    const precisionHeader =
      ChannelTemplateRecords?.deviceType === "DEPTHSERIES"
        ? "Precision (ft)"
        : "Precision (Sec)";
    const dataGapHeader =
      ChannelTemplateRecords?.deviceType === "DEPTHSERIES"
        ? "Data Gap (ft)"
        : "Data Gap (Sec)";
    const frequencyHeader =
      ChannelTemplateRecords?.deviceType === "DEPTHSERIES"
        ? "Frequency (ft)"
        : "Frequency (Sec)";
    const latencyHeader =
      ChannelTemplateRecords?.deviceType === "DEPTHSERIES"
        ? "Latency (ft)"
        : "Latency (Sec)";
    const dataCountHeader =
      ChannelTemplateRecords?.deviceType === "DEPTHSERIES"
        ? "Data Count (ft)"
        : "Data Count (Sec)";

    const roleColumns = [
      {
        accessorKey: "startPoint",
        header: "Start Point",
        enableEditing: false,
        enableResizing: true,
        size: 10,
      },
      {
        accessorKey: "endPoint",
        header: "End Point",
        enableResizing: true,
        size: 10,
      },
      {
        accessorKey: "min",
        header: minHeader,
        enableEditing: false,
        enableResizing: true,
        size: 10,
      },
      {
        accessorKey: "stale",
        header: staleHeader,
        enableEditing: false,
        enableResizing: true,
        size: 10,
      },
      {
        accessorKey: "max",
        header: maxHeader,
        enableEditing: false,
        enableResizing: true,
        size: 10,
      },
      {
        accessorKey: "precision",
        header: precisionHeader,
        enableEditing: false,
        enableResizing: true,
        size: 10,
      },
      {
        accessorKey: "dataGap",
        header: dataGapHeader,
        enableEditing: false,
        enableResizing: true,
        size: 10,
      },
      {
        accessorKey: "frequency",
        header: frequencyHeader,
        enableEditing: false,
        enableResizing: true,
        size: 10,
      },
      {
        accessorKey: "latency",
        header: latencyHeader,
        enableEditing: false,
        enableResizing: true,
        size: 10,
      },
      {
        accessorKey: "dataCount",
        header: dataCountHeader,
        enableEditing: false,
        enableResizing: true,
        size: 10,
      },
    ];
    roleColumns.forEach((column) => {
      const aspectMatch = pieAspectData.find(
        (aspect) => aspect.name === column.accessorKey
      );
      if (aspectMatch) {
        column.header = (
          <div>
            {column.header}
            <br />
            {`Avg (${aspectMatch.value})`}
          </div>
        );
      }
    });

    return roleColumns;
  }, [ChannelTemplateRecords?.deviceType, aspectTemplateDayRecords]);

  const modifiedAspectTemplateDayRecords = useMemo(() => {
    return aspectTemplateDayRecordsTime.map((entry) => {
      return {
        ...entry,
        min:
          entry.min == undefined || entry.min == null || entry.min === ""
            ? "NOT CALCULATING"
            : entry.min,
        stale:
          entry.stale == undefined || entry.stale == null || entry.stale === ""
            ? "NOT CALCULATING"
            : entry.stale,
        max:
          entry.max == undefined || entry.max == null || entry.max === ""
            ? "NOT CALCULATING"
            : entry.max,
        precision:
          entry.precision == undefined ||
          entry.precision == null ||
          entry.precision === ""
            ? "NOT CALCULATING"
            : entry.precision,
        dataGap:
          entry.dataGap == undefined ||
          entry.dataGap == null ||
          entry.dataGap === ""
            ? "NOT CALCULATING"
            : entry.dataGap,
        frequency:
          entry.frequency == undefined ||
          entry.frequency == null ||
          entry.frequency === ""
            ? "NOT CALCULATING"
            : entry.frequency,
        latency:
          entry.latency == undefined ||
          entry.latency == null ||
          entry.latency === ""
            ? "NOT CALCULATING"
            : entry.latency,
        dataCount:
          entry.dataCount == undefined ||
          entry.dataCount == null ||
          entry.dataCount === ""
            ? "NOT CALCULATING"
            : entry.dataCount,
      };
    });
  });

  const handleAspectBarClick = (data) => {
    setShow(true);
    setClickedAspectDate(data.name);
    setDvdate(data);
  };

  const barAspectData =
    aspectTemplateDayRecords && aspectTemplateDayRecords
      ? aspectTemplateDayRecords.map((entry) => entry.range)
      : [];

  const chartData = Object.keys(dataProviderAll).reduce((result, provider) => {
    Object.keys(dataProviderAll[provider]).forEach((date) => {
      const value = isInverted
        ? 100 - dataProviderAll[provider][date]
        : dataProviderAll[provider][date];
      const existingData = result.find((item) => item.date === date);

      if (value !== 0) {
        if (existingData) {
          existingData[provider] = value;
        } else {
          result.push({ date, [provider]: value });
        }
      }
    });

    return result;
  }, []);

  chartData.sort((a, b) => new Date(a.date) - new Date(b.date));

  const handlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };
  const handleStartChange = () => {
    setPageIndex(0);
  };

  const handleEndChange = () => {
    const totalPages = Math.ceil(aspectdayTotalRecords / pageSize);
    setPageIndex(totalPages - 1);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageIndex(0);
  };

  useEffect(() => {
    if (
      !modifiedAspectTemplateDayRecords ||
      modifiedAspectTemplateDayRecords.length === 0
    )
      return;

    if (!svgRef.current || !svgRef.current.parentNode) return; // ✅ SAFETY CHECK

    const svg = d3.select(svgRef.current);
    svg.selectAll("*").remove(); // Clear previous chart

    const container = svgRef.current.parentNode;
    const { width: containerWidth, height: containerHeight } =
      container.getBoundingClientRect();
    const width = containerWidth || 600; // Fallback to 600 if no container width
    const height = containerHeight || 600; // Fallback to 600 if no container height
    const innerRadius = 0;
    const outerRadius = Math.min(width, height) / 2 - 70;

    svg.attr("width", width).attr("height", height);

    const g = svg
      .append("g")
      .attr("transform", `translate(${width / 2}, ${height / 2})`);

    const metrics = [
      "min",
      "stale",
      "max",
      "precision",
      "dataGap",
      "frequency",
      "latency",
      "dataCount",
    ];
    const data = metrics.map((metric) => ({
      metric,
      value: pieAspectData.find((d) => d.name === metric)?.value || 0,
    }));

    // 🔵 FIXED COLOR MAPPING
    const colorMap = {
      min: "#4CAF50",
      stale: "#2196F3",
      max: "#FFC107",
      precision: "#E91E63",
      dataGap: "#9C27B0",
      frequency: "#FF5722",
      latency: "#3F51B5",
      dataCount: "#00BCD4",
    };

    const maxValue = d3.max(data, (d) => (isNaN(d.value) ? 0 : d.value)) || 1;
    const angleScale = d3
      .scaleBand()
      .domain(metrics)
      .range([0, 2 * Math.PI])
      .padding(0.1);

    const radiusScale = d3
      .scaleLinear()
      .domain([0, 200])
      .range([innerRadius, outerRadius]);

    const colorScale = d3.scaleOrdinal().domain(metrics).range(colors);

    const arc = d3
      .arc()
      .innerRadius(innerRadius)
      .outerRadius((d) => radiusScale(isNaN(d.value) ? 0 : 200 - d.value))
      .startAngle((d) => angleScale(d.metric))
      .endAngle((d) => angleScale(d.metric) + angleScale.bandwidth())
      .padAngle(0.01)
      .padRadius(innerRadius);

    const labelArc = d3
      .arc()
      // .innerRadius(d => radiusScale(isNaN(d.value) ? 0 : d.value) + 5)
      // .outerRadius(d => radiusScale(isNaN(d.value) ? 0 : d.value) + 5)
      .innerRadius(outerRadius + 10)
      .outerRadius(outerRadius + 10)
      .startAngle((d) => angleScale(d.metric))
      .endAngle((d) => angleScale(d.metric) + angleScale.bandwidth());

    // const borderArc = d3.arc()
    //   .innerRadius(innerRadius)
    //   .outerRadius(outerRadius + 10) // Extend border to label text position
    //   .startAngle(d => angleScale(d.metric))
    //   .endAngle(d => angleScale(d.metric) + angleScale.bandwidth())
    //   .padAngle(0.01)
    //   .padRadius(innerRadius);

    const tooltip = d3
      .select("body")
      .append("div")
      .attr("class", "tooltip")
      .style("position", "absolute")
      .style("background", "#2b2b2b")
      .style("border", "1px solid #555")
      .style("color", "#c7c7c7")
      .style("padding", "5px")
      .style("font-size", "12px")
      .style("pointer-events", "none")
      .style("opacity", 0);

    g.selectAll(".bar")
      .data(data)
      .enter()
      .append("path")
      .attr("class", "bar")
      // .attr("fill", d => colorMap[d.metric] || "#999")
      .attr("fill", (d) => {
        const baseColor = colorMap[d.metric] || "#999";
        return d3.color(baseColor).brighter(0.8).toString(); // Lighter version of the base color
      })
      // .attr("fill", d => {
      //   const value = isNaN(d.value) ? 0 : d.value;
      //   return value >= 95 ? "#66b266" : value >= 75 ? "#ffd96a" : "#ff6666";
      // })
      .attr("d", arc)
      .style("cursor", "pointer")
      // .style("stroke",  "#c7c7c7") // Border color matches original colorMap
      .style("stroke-width", 2) // Fixed border width for all bars
      .on("click", (event, d) => handleAspectBarClick({ startPoint: d.metric }))
      .on("mousemove", function (event, d) {
        d3.select(this).attr("opacity", 0.7);
        tooltip
          .style("left", event.pageX + 10 + "px")
          .style("top", event.pageY - 10 + "px")
          .style("opacity", 1)
          .html(
            `${d.metric}: ${
              isNaN(d.value)
                ? "NOT CALCULATING"
                : parseFloat(d.value).toFixed(2)
            }`
          );
      })
      .on("mouseout", function () {
        d3.select(this).attr("opacity", 1);
        tooltip.style("opacity", 0);
      });

    // g.selectAll(".bar-border")
    // .data(data)
    // .enter()
    // .append("path")
    // .attr("class", "bar-border")
    // .attr("d", borderArc)
    // .attr("fill", "none")
    // .attr("stroke",   "#c7c7c7") // Border color matches original colorMap
    // .attr("stroke-width", 1); // Fixed border width

    // Define paths for text to follow
    g.selectAll(".label-path")
      .data(data)
      .enter()
      .append("path")
      .attr("id", (d, i) => `label-path-${i}`)
      .attr("d", labelArc)
      .style("fill", "none")
      .style("stroke", "none");

    // Add curved text labels
    g.selectAll(".label")
      .data(data)
      .enter()
      .append("text")
      .attr("fill", "#c7c7c7")
      .attr("font-size", "12px")
      .attr("dy", -2) // Adjust vertical alignment
      .append("textPath")
      .attr("xlink:href", (d, i) => `#label-path-${i}`)
      .attr("startOffset", "25%") // Center text on the arc
      .attr("text-anchor", "middle")
       .text((d) =>
    d.metric
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/^./, (str) => str.toUpperCase())
  );

    // Custom radial grid
    const gridTicks = radiusScale.ticks(10).slice(1); // Skip zero to avoid inner circle
    g.selectAll(".grid-circle")
      .data(gridTicks)
      .enter()
      .append("circle")
      .attr("r", (d) => radiusScale(d))
      .attr("fill", "none")
      .attr("stroke", "#444")
      .attr("stroke-opacity", 0.3);

    // g.selectAll(".grid-label")
    //   .data(gridTicks)
    //   .enter()
    //   .append("text")
    //   .attr("x", 0)
    //   .attr("y", d => -radiusScale(d))
    //   .attr("dy", "-0.3em")
    //   .attr("fill", "#c7c7c7")
    //   .attr("font-size", "10px")
    //   .attr("text-anchor", "middle")
    //   .text(d => d.toFixed(2));

    return () => {
      tooltip.remove();
    };
  }, [modifiedAspectTemplateDayRecords, pieAspectData]);

  const handleSwitchChange = (event) => {
    setSwitchChange(event.target.checked);
  };
  return (
    <>
      <style>
        {`
          .tooltip {
            z-index: 1000;
            pointer-events: none;
          }
        `}
      </style>
      <DataViewer
        show={show}
        handleClose={handleClose}
        rig={dropdownRig}
        well={selectedWell}
        log={clickedLog}
        channel={smallestMnemonic}
        DVdate={DVdate}
        dataProvider={selectedDataProvider}
        deviceType={ChannelTemplateRecords?.deviceType}
      />
      <Card
        className={"w-100 dqgraph-card"}
        style={{
          height: "89vh",
          border: "none",
          color: "#c7c7c7",
          backgroundColor: "#242424",
        }}
      >
        <Card.Body
          className={`dqgraph_content dqgraph2_content`}
          style={{ overflow: "hidden", padding: "0px" }}
        >
          <div
            className={"col-md-12 dqgraph_sub_content"}
            style={{
              backgroundColor: "#242424",
              borderRadius: "5px",
              height: "100%",
              paddingLeft: "0px",
              paddingRight: "0px",
              overflowY: !clickedDate || !clickedLog ? "auto" : "hidden",
            }}
          >
            <div
              className={`col-md-12 d-flex dqgraph2_header`}
              style={{ paddingTop: "3vh", height: "9vh" }}
            >
              <div className="d-flex rechart-data">
                {!clickedDate && !clickedLog ? (
                  <div>
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      variant="contained"
                      className="mr-4"
                      cursor="pointer"
                      onClick={resetGroupedChartData}
                      style={{
                        fontSize: "23px",
                        marginTop: "6px",
                        color: "#c7c7c7",
                      }}
                    />
                  </div>
                ) : null}

                {clickedDate || clickedLog ? (
                  <div>
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      variant="contained"
                      className="mr-4"
                      cursor="pointer"
                      onClick={() => {
                        setClickedDate("");
                        setClickedMnemonic("");
                        setClickedLog("");
                        setSmallestMnemonic("");
                      }}
                      style={{
                        fontSize: "23px",
                        marginTop: "6px",
                        color: "#c7c7c7",
                      }}
                    />
                  </div>
                ) : null}
                <div>
                  <Stack
                    direction="row"
                    alignItems="center"
                    className="mr-2 mt-2"
                  >
                    {/* <Typography onClick={() => handleButtonClick('aswi')}>ASWI</Typography> */}
                    {/* <Switch
                      checked={selectDropdown === 'dqi'}
                      className="switchCase"
                      style={{ color: "#c7c7c7" }}
                      onClick={() => handleButtonClick(selectDropdown === 'aswi' ? 'dqi' : 'aswi')}
                      disabled
                    /> */}
                    <Typography onClick={() => handleButtonClick("dqi")}>
                      DQI
                    </Typography>
                  </Stack>
                </div>
              </div>
              <div className="d-flex rechart-data-1">
                {!clickedDate && !clickedLog ? (
                  <div>
                    <Stack direction="row" alignItems="center" className="mr-2">
                      <Typography
                        onClick={() => setIsInverted(!isInverted)}
                        sx={{
                          color: isInverted ? "#888" : "#fff",
                          cursor: "pointer",
                          fontWeight: isInverted ? "normal" : "bold",
                        }}
                      >
                        Not Inverted
                      </Typography>
                      <Switch
                        checked={isInverted}
                        className="switchCase"
                        style={{ color: "#c7c7c7" }}
                        onClick={() => setIsInverted(!isInverted)}
                      />
                      <Typography
                        onClick={() => setIsInverted(isInverted)}
                        sx={{
                          color: isInverted ? "#fff" : "#888",
                          cursor: "pointer",
                          fontWeight: isInverted ? "bold" : "normal",
                        }}
                      >
                        Inverted
                      </Typography>
                    </Stack>
                  </div>
                ) : null}

                <div className="mr-2">
                  <FormControl
                    style={{ width: "150px", color: "#c7c7c7" }}
                    className="dropdownHeight for_dropdown"
                  >
                    <InputLabel style={{ color: "#c7c7c7" }}>
                      Select a Rig
                    </InputLabel>
                    <style>
                      {`
                        .dropdownHeight .MuiSelect-select {
                          padding: 6px !important;
                          font-size: 12px !important;
                          color: #c7c7c7 !important;
                        }     
                      `}
                    </style>
                    <Select
                      value={dropdownRig}
                      onChange={handleRigChange}
                      label="Select a Rig"
                      disabled={clickedDate || clickedLog}
                    >
                      {Object.keys(rigWellData).map((rig) => (
                        <MenuItem
                          key={rig}
                          value={rig}
                          className="dropdown_vertical"
                        >
                          {rig}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <div className="mr-2">
                  <FormControl
                    style={{ width: "150px" }}
                    className="dropdownHeight for_dropdown"
                  >
                    <style>
                      {`
      .for_dropdown .MuiOutlinedInput-notchedOutline {
        border-color: #c7c7c7 !important;
      }

      .for_dropdown .MuiSelect-icon {
        color: #c7c7c7 !important;
      }

      .for_dropdown .Mui-disabled {
        color: #c7c7c7 !important;
        background-color: #2b2b2b !important;
        -webkit-text-fill-color: #c7c7c7 !important; /* for Safari */
        opacity: 1 !important; /* Override MUI default disabled opacity */
      }

      .for_dropdown .MuiInputLabel-root.Mui-disabled {
        color: #c7c7c7 !important;
      }

      .for_dropdown .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
        border-color: #555 !important;
      }
    `}
                    </style>

                    <InputLabel style={{ color: "#c7c7c7" }}>
                      Select a well
                    </InputLabel>

                    <Select
                      value={selectedWell}
                      onChange={handleChange}
                      label="Select a well"
                      disabled={clickedDate || clickedLog}
                      sx={{
                        color: "#c7c7c7",
                        ".MuiSelect-select": {
                          color: "#c7c7c7",
                        },
                      }}
                    >
                      {rigWellData[dropdownRig]?.map((well) => (
                        <MenuItem
                          key={well}
                          value={well}
                          className="dropdown_vertical"
                        >
                          {well}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <div className="mr-2">
                  <FormControl
                    style={{ width: "150px", color: "#c7c7c7" }}
                    className="dropdownHeight for_dropdown"
                  >
                    <InputLabel style={{ color: "#c7c7c7" }}>
                      Select a Data Provider
                    </InputLabel>
                    <Select
                      value={selectedDataProvider}
                      onChange={handleDataProviderChange}
                      label="Select a Data Provider"
                      disabled={clickedDate || clickedLog}
                    >
                      {wellProviderData[selectedWell]?.map((item, index) => (
                        <MenuItem
                          key={index}
                          value={item}
                          className="dropdown_vertical"
                        >
                          {item}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                {clickedDate || clickedLog ? (
                  <>
                    <div className="mr-2">
                      {/* <FormControl style={{ width: "150px" }} className="dropdownHeight for_dropdown">
                        <InputLabel className="custom-input-label" >Select a Date</InputLabel>
                        <Select
                          value={clickedDate}
                          onChange={handleDateChange}
                          label="Select a Date"
                        >
                          {pieWellData.map((date) => {
                            return (
                              <MenuItem key={date.name} value={date.name} className="dropdown_vertical">
                                {date.name}
                              </MenuItem>
                            )
                          })}
                        </Select>
                      </FormControl> */}
                      <FormControl
                        style={{ width: "150px", color: "#c7c7c7" }}
                        className="dropdownHeight for_dropdown"
                      >
                        <InputLabel
                          style={{ color: "#c7c7c7" }}
                          className="custom-input-label"
                        >
                          Select a Date
                        </InputLabel>
                        <Select
                          value={clickedDate}
                          onChange={handleDateChange}
                          label="Select a Date"
                        >
                          {pieWellData
                            .slice() // Create a shallow copy to avoid mutating the original array
                            .sort((a, b) => new Date(a.name) - new Date(b.name)) // Sort dates
                            .map((date) => {
                              return (
                                <MenuItem
                                  key={date.name}
                                  value={date.name}
                                  className="dropdown_vertical"
                                >
                                  {date.name}
                                </MenuItem>
                              );
                            })}
                        </Select>
                      </FormControl>
                    </div>

                    <div className="mr-2">
                      <FormControl
                        style={{ width: "150px", color: "#c7c7c7" }}
                        className="dropdownHeight for_dropdown"
                      >
                        <InputLabel style={{ color: "#c7c7c7" }}>
                          Select a Log
                        </InputLabel>
                        <Select
                          value={clickedLog}
                          onChange={handleLogChange}
                          label="Select a Log"
                        >
                          {Object.keys(logMnemonicData)?.map((log) => (
                            <MenuItem
                              key={log}
                              value={log}
                              className="dropdown_vertical"
                            >
                              {log}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>

                    <div>
                      {/* <FormControl style={{ width: "150px" }} className="dropdownHeight for_dropdown">
                        <InputLabel>Select a Mnemonic</InputLabel>
                        <Select
                          value={smallestMnemonic}
                          onChange={handleMnemonicChange}
                          label="Select a Mnemonic"
                        >
                          {logMnemonicData[clickedLog]?.map((mnemonic, index) => {

                            const [[key, value]] = Object.entries(mnemonic);

                            return (
                              <MenuItem key={index} value={key} className="dropdown_vertical">
                                {`${key} (${value})`}
                              </MenuItem>
                            );
                          })}

                        </Select>
                      </FormControl> */}
                    </div>
                  </>
                ) : null}
              </div>
            </div>

            {!loading ? (
              <>
                {pieWellData && pieWellData.length > 0 ? (
                  <>
                    {/* <div className={`graph1-content ${clickedDate || clickedLog ? 'graph2-content' : ''}`} style={{ fontSize: "16px", display: "flex", flexDirection: "column", paddingBottom: "23px", paddingTop: "2vh", justifyContent: "flex-end", paddingRight: "5px" }}>
                    {!clickedDate || !clickedLog ? (
                      <>

                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "flex-end" }}>
                          <span><b>Start Time:</b> {smallestDate} GMT+00:00</span> &nbsp;&nbsp;
                          <span><b>End Time:</b> {largestDate} GMT+00:00</span>

                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', justifyContent: "flex-end" }}>

                          {barLogData.map((bars) => (

                            <Grid >
                              <Paper
                                style={{
                                  border: "1px solid grey",
                                  textAlign: "center",
                                  margin: '3px 3px',
                                  fontSize: "12px",
                                  padding: "3px",
                                  backgroundColor: 'white',
                                  color: 'black',
                                  cursor: "pointer",
                                }}
                                className="dateBox"

                                onClick={() => handleLogBar(bars.name)}
                              >
                                <Box>{bars.name.slice(5, 11)}</Box>
                                <hr style={{ margin: "0.1rem 0" }} />
                                <Box>{parseFloat(bars.value).toFixed(2)}</Box>
                              </Paper>
                            </Grid>))}

                        </div></>) : ""}

                  </div> */}
                    {(!clickedDate || !clickedLog) && (
                      <Card
                        className={"w-100 dashboard-card1"}
                        style={{
                          backgroundColor: "#333333",
                          padding: "15px",
                          height: "80vh",
                          border: "none",
                          overflow: "auto",
                        }}
                      >
                        <Card.Body
                          style={{ overflow: "hidden", padding: "0px" }}
                        >
                          <div
                            className={
                              "d-flex col-md-12 dqgraph_sub_content1 justify-content-between p-0"
                            }
                            style={{ height: "100%" }}
                          >
                            <div
                              className={
                                "col-md-6 bar-chart-content d-flex align-items-center lineDataProvider"
                              }
                              style={{
                                position: "relative",
                                backgroundColor: "#242424",
                                borderRadius: "5px",
                                overflowY: "auto",
                                overflowX: "hidden",
                              }}
                            >
                              {/* --------------------------------well pie----------------------------- */}

                              <span
                                style={{ position: "absolute", top: "5px" }}
                              >
                                <b>Data Provoider</b>
                              </span>
                              <div
                                style={{ width: "100%" }}
                                className="barChartDate wellPieWidth"
                              >
                                <style>
                                  {`
                      .barChartDate .recharts-wrapper svg {
                       overflow: visible !important;
                      },
                      .barChartDate .recharts-responsive-container .recharts-wrapper .recharts-legend-wrapper{
                        bottom: -50px !important; 
                      }
                        `}
                                </style>

                                {!clickedDate && (
                                  <ResponsiveContainer
                                    width="100%"
                                    height={450}
                                  >
                                    <LineChart data={chartData}>
                                      {console.log("chartData", chartData)}
                                      <XAxis
                                        dataKey="date"
                                        angle={-90}
                                        dy={35}
                                        height={110}
                                        tick={{ fill: "#c7c7c7", fontSize: 11 }}
                                        axisLine={{ stroke: "#c7c7c7" }}
                                        tickLine={{ stroke: "#c7c7c7" }}
                                      >
                                        <Label
                                          value="Date"
                                          style={{ fontWeight: "bolder" }}
                                          position="insideBottom"
                                          fill="#c7c7c7"
                                          offset={10}
                                        />
                                      </XAxis>

                                      <YAxis
                                        tick={{ fill: "#c7c7c7" }}
                                        axisLine={{ stroke: "#c7c7c7" }}
                                        tickLine={{ stroke: "#c7c7c7" }}
                                      >
                                        <Label
                                          value={
                                            selectDropdown === "dqi"
                                              ? "Data Quality Index"
                                              : "Attribute Score Weighted Index"
                                          }
                                          style={{ fontWeight: "bolder" }}
                                          position="insideLeft"
                                          angle={-90}
                                          fill="#c7c7c7"
                                          dy={
                                            selectDropdown === "dqi" ? 50 : 100
                                          }
                                        />
                                      </YAxis>

                                      {Object.keys(dataProviderAll).map(
                                        (provider, index) => {
                                          // 1. Find latest value from chartData for this provider
                                          let value = null;
                                          for (
                                            let i = chartData.length - 1;
                                            i >= 0;
                                            i--
                                          ) {
                                            if (
                                              chartData[i][provider] !== null &&
                                              chartData[i][provider] !==
                                                undefined
                                            ) {
                                              value = chartData[i][provider];
                                              break;
                                            }
                                          }

                                          // 2. Determine stroke color based on value
                                          const fillColor = isInverted
                                            ? value > 25 && value <= 100
                                              ? "#ff6666"
                                              : value > 5 && value <= 25
                                              ? "#ffd96a"
                                              : value >= 0 && value <= 5
                                              ? "#66b266"
                                              : null
                                            : value >= 0 && value < 75
                                            ? "#ff6666"
                                            : value >= 75 && value < 95
                                            ? "#ffd96a"
                                            : value >= 95
                                            ? "#66b266"
                                            : null;

                                          // 3. Return the colored Line
                                          return (
                                            <Line
                                              key={index}
                                              type="monotone"
                                              dataKey={provider}
                                              connectNulls={true}
                                              stroke={
                                                colors[index % colors.length]
                                              }
                                              strokeWidth={2}
                                              dot={(dotProps) => {
                                                const pointValue =
                                                  dotProps.payload[provider];

                                                // Skip rendering dot if no data
                                                if (
                                                  pointValue === null ||
                                                  pointValue === undefined
                                                )
                                                  return null;

                                                const fillColor = isInverted
                                                  ? pointValue > 25 &&
                                                    pointValue <= 100
                                                    ? "#ff6666"
                                                    : pointValue > 5 &&
                                                      pointValue <= 25
                                                    ? "#ffd96a"
                                                    : pointValue >= 0 &&
                                                      pointValue <= 5
                                                    ? "#66b266"
                                                    : null
                                                  : pointValue >= 0 &&
                                                    pointValue < 75
                                                  ? "#ff6666"
                                                  : pointValue >= 75 &&
                                                    pointValue < 95
                                                  ? "#ffd96a"
                                                  : pointValue >= 95
                                                  ? "#66b266"
                                                  : null;

                                                return (
                                                  <circle
                                                    cx={dotProps.cx}
                                                    cy={dotProps.cy}
                                                    r={3}
                                                    fill={fillColor}
                                                    stroke="#fff"
                                                    strokeWidth={1}
                                                  />
                                                );
                                              }}
                                            />
                                          );
                                        }
                                      )}

                                      <Brush
                                        dataKey="date"
                                        height={20}
                                        stroke="#c7c7c7"
                                        fill="#2b2b2b"
                                      />

                                      <Tooltip
                                        cursor={{ fill: "transparent" }}
                                        formatter={(value) =>
                                          `${parseFloat(value).toFixed(2)} %`
                                        }
                                        contentStyle={{
                                          backgroundColor: "#2b2b2b",
                                          border: "1px solid #555",
                                          color: "#c7c7c7",
                                          fontSize: "12px",
                                        }}
                                        itemStyle={{
                                          color: "#c7c7c7",
                                          fontSize: "12px",
                                        }}
                                        labelStyle={{
                                          color: "#c7c7c7",
                                          fontWeight: "bold",
                                        }}
                                      />

                                      <Legend iconType="square" />
                                    </LineChart>
                                  </ResponsiveContainer>
                                )}
                              </div>
                            </div>
                            <div
                              className={
                                "col-md-6 d-flex align-items-center barLog"
                              }
                              style={{
                                position: "relative",
                                backgroundColor: "#242424",
                                borderRadius: "5px",
                                marginLeft: "15px",
                                paddingRight: "30px",
                                overflowY: "auto",
                                overflowX: "hidden",
                              }}
                            >
                              <span
                                style={{ position: "absolute", top: "5px" }}
                              >
                                <b>Selected Data Provoider: </b>
                                {selectedDataProvider}
                              </span>
                              <div
                                style={{ width: "100%" }}
                                className="barChartDate wellPieWidth"
                              >
                                <style>
                                  {`
                      .barChartDate .recharts-wrapper svg {
                       overflow: visible !important;
                      }
                        `}
                                </style>

                                {/* --------------------------------well log bar----------------------------- */}
                                {!clickedDate && (
                                  <ResponsiveContainer
                                    width="100%"
                                    height={450}
                                  >
                                    <BarChart data={barLogData}>
                                      <XAxis
                                        dataKey="name"
                                        style={{ fontSize: "11px" }}
                                        angle={-90}
                                        dy={35}
                                        height={110}
                                        tick={{ fill: "#c7c7c7", fontSize: 11 }}
                                        axisLine={{ stroke: "#c7c7c7" }}
                                        tickLine={{ stroke: "#c7c7c7" }}
                                      >
                                        <Label
                                          value="Date"
                                          style={{ fontWeight: "bolder" }}
                                          position="insideBottom"
                                          offset={10}
                                          fill="#c7c7c7"
                                        />
                                      </XAxis>
                                      <YAxis
                                        tick={{ fill: "#c7c7c7", fontSize: 11 }}
                                        axisLine={{ stroke: "#c7c7c7" }}
                                        tickLine={{ stroke: "#c7c7c7" }}
                                      >
                                        <Label
                                          value={
                                            selectDropdown === "dqi"
                                              ? "Data Quality Index"
                                              : "Attribute Score Weighted Index"
                                          }
                                          style={{ fontWeight: "bolder" }}
                                          position="insideLeft"
                                          angle={-90}
                                          fill="#c7c7c7"
                                          dy={
                                            selectDropdown === "dqi" ? 50 : 100
                                          }
                                        />
                                      </YAxis>
                                      <Bar
                                        dataKey="value"
                                        cursor="pointer"
                                        onClick={(data) =>
                                          handleLogBar(data.name)
                                        }
                                      >
                                        {barLogData.map((entry, index) => {
                                          const value = entry.value;
                                          // const fillColor = isInverted ? (
                                          //   value <= 10 ? "#212C68" :
                                          //     value > 10 && value <= 50 ? "#48578E" :
                                          //       value > 50 && value <= 70 ? "#296d98" :
                                          //         value > 70 && value <= 90 ? "#296d98" :
                                          //           value > 90 ? 'red' : null

                                          // ) : (
                                          //   value < 20 ? "red" :
                                          //     value >= 20 && value < 50 ? "#296d98" :
                                          //       value >= 50 && value < 70 ? "#46a2da" :
                                          //         value >= 70 && value < 90 ? "#48578E" :
                                          //           value >= 90 ? '#212C68' : null
                                          // )

                                          const fillColor = isInverted
                                            ? value > 25 && value <= 100
                                              ? "#ff6666"
                                              : value > 5 && value <= 25
                                              ? "#ffd96a"
                                              : value >= 0 && value <= 5
                                              ? "#66b266"
                                              : null
                                            : value >= 0 && value < 75
                                            ? "#ff6666"
                                            : value >= 75 && value < 95
                                            ? "#ffd96a"
                                            : value >= 95
                                            ? "#66b266"
                                            : null;
                                          return (
                                            <Cell
                                              key={index}
                                              fill={fillColor}
                                            />
                                          );
                                        })}

                                        <LabelList
                                          position="insideCenter"
                                          fill="black"
                                          style={{ fontSize: "16px" }}
                                          dataKey="value"
                                          angle={-90}
                                          formatter={(value) =>
                                            `${parseFloat(value).toFixed(2)}%`
                                          }
                                        />
                                      </Bar>
                                      <Tooltip
                                        cursor={{ fill: "transparent" }}
                                        formatter={(value) =>
                                          `${parseFloat(value).toFixed(2)} %`
                                        }
                                        contentStyle={{
                                          backgroundColor: "#2b2b2b",
                                          border: "1px solid #555",
                                          color: "#c7c7c7",
                                          fontSize: "12px",
                                        }}
                                        itemStyle={{
                                          color: "#c7c7c7",
                                          fontSize: "12px",
                                        }}
                                        labelStyle={{
                                          color: "#c7c7c7",
                                          fontWeight: "bold",
                                        }}
                                      />
                                      <Brush
                                        dataKey="name"
                                        height={20}
                                        stroke="#c7c7c7"
                                        fill="#2b2b2b"
                                      />

                                      {CommonLegend}
                                    </BarChart>
                                  </ResponsiveContainer>
                                )}
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    )}
                  </>
                ) : (
                  <h5 className="d-flex justify-content-center mt-5">
                    Data quality not available for selected well data provider..
                  </h5>
                )}
              </>
            ) : (
              ""
            )}

            {(clickedLog || clickedDate) && pieWellData.length > 0 && (
              <>
                {barMnemonicData.length > 0 ? (
                  <>
                    <Card
                      className={"w-100 dashboard-card1"}
                      style={{
                        backgroundColor: "#333333",
                        padding: "15px",
                        height: "80vh",
                        border: "none",
                      }}
                    >
                      <Card.Body style={{ overflow: "hidden", padding: "0px" }}>
                        <div
                          className={
                            "d-flex col-md-12 dqgraph_sub_content1 justify-content-between p-0"
                          }
                          style={{ height: "100%" }}
                        >
                          <div
                            className={"col-md-3 bar-chart-content d-flex"}
                            style={{
                              padding: "10px",
                              flexDirection: "column",
                              backgroundColor: "#242424",
                              borderRadius: "5px",
                              overflowY: "auto",
                              overflowX: "hidden",
                              position: "relative",
                            }}
                          >
                            <span
                              style={{
                                marginBottom: "7px",
                                display: "block",
                                wordBreak: "break-all",
                              }}
                            >
                              <b>Selected Log: </b>
                              {clickedLog}
                            </span>

                            <ResponsiveContainer
                              width="100%"
                              height="87%"
                              className="mnemonic_graph"
                            >
                              <BarChart
                                data={barMnemonicData}
                                layout="vertical"
                                style={{ margin: "10px 0px" }}
                              >
                                <XAxis
                                  type="number"
                                  tick={{ fill: "#c7c7c7" }}
                                  axisLine={{ stroke: "#c7c7c7" }}
                                  tickLine={{ stroke: "#c7c7c7" }}
                                />
                                <YAxis
                                  dataKey="name"
                                  type="category"
                                  className="custom-y-axis"
                                  interval={
                                    barMnemonicData.length > 10
                                      ? 0
                                      : "preserveStartEnd"
                                  }
                                  tickFormatter={(name) => {
                                    const maxCharacters = 4;
                                    return name.length > maxCharacters
                                      ? name.substring(0, maxCharacters) + "..."
                                      : name;
                                  }}
                                  tick={{ fill: "#c7c7c7" }}
                                  axisLine={{ stroke: "#c7c7c7" }}
                                  tickLine={{ stroke: "#c7c7c7" }}
                                >
                                  <Label
                                    value="Mnemonics"
                                    style={{ fontWeight: "bolder" }}
                                    position="insideLeft"
                                    angle={-90}
                                    dy={50}
                                    fill="#c7c7c7"
                                  />
                                </YAxis>

                                <Bar
                                  dataKey="value"
                                  cursor="pointer"
                                  onClick={(data) => handleChannelClick(data)}
                                >
                                  {barMnemonicData.map(
                                    (dataItem, dataIndex) => {
                                      const value = dataItem.value;
                                      const fillColor =
                                        value >= 0 && value < 75
                                          ? "#ff6666"
                                          : value >= 75 && value < 95
                                          ? "#ffd96a"
                                          : value >= 95
                                          ? "#66b266"
                                          : null;

                                      const isSelected =
                                        (clickedMnemonic ||
                                          smallestMnemonic) === dataItem.name;

                                      return (
                                        <Cell
                                          key={dataIndex}
                                          fill={fillColor}
                                          stroke={isSelected ? "#888888" : null}
                                          strokeWidth={isSelected ? 3 : 0}
                                          strokeDasharray={
                                            isSelected ? "4 2" : null
                                          } // Dotted border
                                        />
                                      );
                                    }
                                  )}

                                  <LabelList
                                    dataKey="value"
                                    position="center"
                                    content={({
                                      x,
                                      y,
                                      width,
                                      height,
                                      value,
                                      index,
                                    }) => {
                                      const isSelected =
                                        (clickedMnemonic ||
                                          smallestMnemonic) ===
                                        barMnemonicData[index].name;

                                      return (
                                        <text
                                          x={x + width / 2} // center horizontally
                                          y={y + height / 2} // center vertically
                                          textAnchor="middle"
                                          dominantBaseline="middle"
                                          style={{
                                            fill: "black",
                                            fontSize: "12px",
                                            fontWeight: isSelected
                                              ? "bold"
                                              : "normal",
                                            pointerEvents: "none",
                                          }}
                                        >
                                          {`${parseFloat(value).toFixed(2)}%`}
                                        </text>
                                      );
                                    }}
                                  />
                                </Bar>

                                <Tooltip
                                  cursor={{ fill: "transparent" }}
                                  formatter={(value) =>
                                    `${parseFloat(value).toFixed(2)} %`
                                  }
                                  contentStyle={{
                                    backgroundColor: "#2b2b2b",
                                    border: "1px solid #555",
                                    color: "#c7c7c7",
                                    fontSize: "12px",
                                  }}
                                  itemStyle={{
                                    color: "#c7c7c7",
                                    fontSize: "12px",
                                  }}
                                  labelStyle={{
                                    color: "#c7c7c7",
                                    fontWeight: "bold",
                                  }}
                                />
                              </BarChart>
                              {CommonLegend1}
                            </ResponsiveContainer>
                          </div>
                          <div
                            className={"col-md-9 d-flex"}
                            style={{
                              padding: "10px",
                              flexDirection: "column",
                              backgroundColor: "#242424",
                              borderRadius: "5px",
                              marginLeft: "15px",
                              paddingRight: "30px",
                            }}
                          >
                            <span
                              style={{
                                marginBottom: "7px",
                                display: "block",
                                wordBreak: "break-all",
                              }}
                            >
                              <b>Selected Mnemonic: </b>
                              {smallestMnemonic}
                              {logMnemonicData[clickedLog] && (
                                <>
                                  {" "}
                                  (
                                  {logMnemonicData[clickedLog].find(
                                    (item) =>
                                      Object.keys(item)[0] === smallestMnemonic
                                  )?.[smallestMnemonic] || ""}
                                  )
                                </>
                              )}
                            </span>
                            <Stack
                              direction="row"
                              alignItems="center"
                              className="mr-4"
                              style={{ color: "#c7c7c7" }}
                            >
                              <Typography
                                onClick={() => {
                                  setSwitchChange(false);
                                }}
                                sx={{
                                  color: switchChange ? "#888" : "#fff",
                                  cursor: "pointer",
                                  fontWeight: switchChange ? "normal" : "bold",
                                }}
                              >
                                Average
                              </Typography>
                              <Switch
                                style={{ color: "#c7c7c7" }}
                                checked={switchChange}
                                onChange={(e) => {
                                  handleSwitchChange(e);
                                }}
                              />
                              <Typography
                                onClick={() => {
                                  setSwitchChange(true);
                                }}
                                sx={{
                                  color: switchChange ? "#fff" : "#888",
                                  cursor: "pointer",
                                  fontWeight: switchChange ? "bold" : "normal",
                                }}
                              >
                                Details
                              </Typography>
                            </Stack>
                            <style>
                              {`
                        .css-1kihoro-MuiPaper-root {
                          background-color: #242424 !important;
                          color: #c7c7c7 !important;
                        }
                        .MuiPaper-root{
                          background-color: #242424 !important;
                        }
                      `}
                            </style>
                            {/* <div style={{ flex: 1, overflow: "auto" }}>
                            <svg ref={svgRef}></svg>
                          </div> */}
                            {switchChange ? (
                              <MaterialReactTable
                                muiTopToolbarProps={{
                                  sx: {
                                    backgroundColor: "#242424",
                                  },
                                }}
                                muiTableHeadProps={{
                                  sx: {
                                    overflow: "auto",
                                    backgroundColor: "#2e2e2e",
                                    "&::-webkit-scrollbar": {
                                      width: "12px",
                                    },
                                    "&::-webkit-scrollbar-thumb": {
                                      backgroundColor: "#444", // darker thumb
                                      borderRadius: "6px",
                                    },
                                    "&::-webkit-scrollbar-thumb:hover": {
                                      backgroundColor: "#555",
                                    },
                                    "&::-webkit-scrollbar-track": {
                                      backgroundColor: "#2e2e2e",
                                    },
                                  },
                                }}
                                muiTablePaperProps={{
                                  sx: {
                                    boxShadow: "none",
                                    height: "100vh",
                                    width: "100%",
                                    position: "static",
                                    display: "block",
                                    overflowY: "auto",
                                    overflowX: "auto",
                                    backgroundColor: "#242424",
                                    scrollbarWidth: "thin",
                                    "&::-webkit-scrollbar": {
                                      width: "12px",
                                    },
                                    "&::-webkit-scrollbar-thumb": {
                                      backgroundColor: "#444",
                                      borderRadius: "6px",
                                    },
                                    "&::-webkit-scrollbar-thumb:hover": {
                                      backgroundColor: "#555",
                                    },
                                    "&::-webkit-scrollbar-track": {
                                      backgroundColor: "#23272f",
                                    },
                                  },
                                }}
                                muiTableContainerProps={{
                                  sx: {
                                    height: "calc(100% - 50px)",
                                    maxHeight: "none",
                                    boxShadow: "none !important",
                                    backgroundColor: "#181818",
                                    overflowY: "auto",
                                    overflowX: "auto",
                                  },
                                }}
                                muiTableHeadCellProps={{
                                  sx: {
                                    backgroundColor: "#2e2e2e",
                                    boxShadow: "none !important",

                                    color: "#fff",
                                  },
                                }}
                                muiTableBodyRowProps={({ row, index }) => ({
                                  sx: {
                                    cursor: "pointer",
                                    boxShadow: "none !important",

                                    backgroundColor: row.getIsSelected()
                                      ? "#1c1c1c"
                                      : "#121212",
                                  },
                                  onClick: () => handleAspectBarClick(row),
                                })}
                                muiTableBodyProps={{
                                  sx: {
                                    overflow: "auto",
                                    scrollbarWidth: "thin",
                                    backgroundColor: "#181818",
                                    "&::-webkit-scrollbar": {
                                      width: "12px",
                                    },
                                    "&::-webkit-scrollbar-thumb": {
                                      backgroundColor: "#444",
                                      borderRadius: "6px",
                                    },
                                    "&::-webkit-scrollbar-thumb:hover": {
                                      backgroundColor: "#555",
                                    },
                                    "&::-webkit-scrollbar-track": {
                                      backgroundColor: "#23272f",
                                    },
                                    "& td": {
                                      padding: "0.5rem",
                                      borderBottom: "1px solid #333",
                                      color: "#c7c7c7",
                                    },
                                  },
                                }}
                                columns={roleColumns}
                                data={modifiedAspectTemplateDayRecords || []}
                                enableRowActions={false}
                                enableEditing={false}
                                enableStickyHeader={true}
                                enableStickyFooter={false}
                                enableDensityToggle={false}
                                enableFullScreenToggle={false}
                                positionActionsColumn="last"
                                editDisplayMode="row"
                                enableFilters={false}
                                enableHiding={false}
                                enablePagination={false}
                                enableTopToolbar={false}
                                renderBottomToolbarCustomActions={({
                                  table,
                                }) => (
                                  <>
                                    <div
                                      style={{
                                        marginLeft: "auto",
                                        color: "#c7c7c7",
                                      }}
                                    >
                                      <span>Rows per Page </span>&nbsp;
                                      <FormControl
                                        variant="standard"
                                        size="small"
                                      >
                                        <Select
                                          value={pageSize}
                                          onChange={(e) =>
                                            handlePageSizeChange(
                                              Number(e.target.value)
                                            )
                                          }
                                          sx={{
                                            color: "#c7c7c7",
                                            ".MuiSelect-icon": {
                                              color: "#c7c7c7",
                                            },
                                            ".MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "#444",
                                              },
                                          }}
                                        >
                                          <MenuItem value={5}>5</MenuItem>
                                          <MenuItem value={10}>10</MenuItem>
                                          <MenuItem value={20}>20</MenuItem>
                                          <MenuItem value={50}>50</MenuItem>
                                          <MenuItem value={100}>100</MenuItem>
                                        </Select>
                                      </FormControl>
                                      &nbsp;
                                      <span>
                                        {pageIndex * pageSize + 1}-
                                        {Math.min(
                                          pageIndex * pageSize + pageSize,
                                          aspectdayTotalRecords
                                        )}{" "}
                                        of &nbsp;
                                        {aspectdayTotalRecords}&nbsp;
                                      </span>
                                      <FirstPageIcon
                                        onClick={() => {
                                          if (pageIndex !== 0) {
                                            handleStartChange();
                                          }
                                        }}
                                        style={{
                                          cursor:
                                            pageIndex === 0
                                              ? "not-allowed"
                                              : "pointer",
                                          color:
                                            pageIndex === 0
                                              ? "rgba(255,255,255,0.26)"
                                              : "#c7c7c7",
                                        }}
                                      />
                                      <NavigateBeforeIcon
                                        onClick={() => {
                                          if (pageIndex !== 0) {
                                            handlePageChange(pageIndex - 1);
                                          }
                                        }}
                                        style={{
                                          cursor:
                                            pageIndex === 0
                                              ? "not-allowed"
                                              : "pointer",
                                          color:
                                            pageIndex === 0
                                              ? "rgba(255,255,255,0.26)"
                                              : "#c7c7c7",
                                        }}
                                      />
                                      <NavigateNextIcon
                                        onClick={() => {
                                          if (
                                            (pageIndex + 1) * pageSize <
                                            aspectdayTotalRecords
                                          ) {
                                            handlePageChange(pageIndex + 1);
                                          }
                                        }}
                                        style={{
                                          cursor:
                                            (pageIndex + 1) * pageSize >=
                                            aspectdayTotalRecords
                                              ? "not-allowed"
                                              : "pointer",
                                          color:
                                            (pageIndex + 1) * pageSize >=
                                            aspectdayTotalRecords
                                              ? "rgba(255,255,255,0.26)"
                                              : "#c7c7c7",
                                        }}
                                      />
                                      <LastPageIcon
                                        onClick={() => {
                                          if (
                                            (pageIndex + 1) * pageSize <
                                            aspectdayTotalRecords
                                          ) {
                                            handleEndChange();
                                          }
                                        }}
                                        style={{
                                          cursor:
                                            (pageIndex + 1) * pageSize >=
                                            aspectdayTotalRecords
                                              ? "not-allowed"
                                              : "pointer",
                                          color:
                                            (pageIndex + 1) * pageSize >=
                                            aspectdayTotalRecords
                                              ? "rgba(255,255,255,0.26)"
                                              : "#c7c7c7",
                                        }}
                                      />
                                    </div>
                                  </>
                                )}
                              />
                            ) : (
                              <div style={{ flex: 1, overflow: "auto" }}>
                                <svg ref={svgRef}></svg>
                              </div>
                            )}
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </>
                ) : (
                  <h5 className="d-flex justify-content-center mt-5">
                    Mnemonic does not exist with the specified details.
                  </h5>
                )}
              </>
            )}
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default DataQualityGraph;
